import React, { useEffect, useState } from 'react'
import './SkinAssessmentGender.scss'
import SkinAssessmentButton from '../../../../../../common/skinAssessmentButton/SkinAssessmentButton'
import { ANONYMOUS_QUESTION_TEMPLATE, SKIN_ASM_CONSTANTS, SKIN_GENDER } from '../../../../../../common/skinAssessmentConstant';

const SkinAssessmentGender = ({ onAnswerSelect }) => {

    const [gender, setGender] = useState(SKIN_GENDER);
    const [nextEnalbled, setNextEnalbled] = useState(false);

    useEffect(() => {
        const savedGender = sessionStorage.getItem('skinAssessmentGender');
        if (!savedGender) return;

        setGender(prev =>
            prev.map(item => ({
                ...item,
                active: item.key === savedGender,
            }))
        );
    }, []);

    const handleGenderSelect = (index) => {
        const updatedGender = gender.map((item, i) => ({
            ...item,
            active: i === index
        }));
        setNextEnalbled(prev => prev = true);
        setGender(updatedGender);
        const selectedGender = updatedGender.find(el => el.active);
        sessionStorage.setItem('skinAssessmentGender', selectedGender?.key);
        onAnswerSelect({ canGoNext: true, nextLabel: SKIN_ASM_CONSTANTS.AGE, question_id: ANONYMOUS_QUESTION_TEMPLATE.GENDER.question_id, question_label: ANONYMOUS_QUESTION_TEMPLATE.GENDER.question_label, answer_ids: [selectedGender.key] });
    }

    return (
        <div className='gender-container'>
            <div className='gender-title'>
                <h5 className='gender-title-text'>
                    {SKIN_ASM_CONSTANTS.USER_GENDER_QUES}
                </h5>
            </div>
            <div className='gender-content'>
                {
                    gender?.map((el, index) => {
                        const imageName = el.active ? `${el.image}-white` : el.image;
                        return (
                            <SkinAssessmentButton
                                key={`gender=${index}`}
                                onBtnClick={() => handleGenderSelect(index)}
                                btnClassName={`gender-btn ${el.active ? 'home-start-gradient' : ''}`}>
                                <img src={`/images/skin-assessment/${imageName}.svg`} />
                                {el.label}
                            </SkinAssessmentButton>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default SkinAssessmentGender
